import styled from "styled-components";

export const ModalTitle = styled.h1`
  margin: 0;
  margin-bottom: ${(props) => props.theme.spacing.small};
  font-size: 1.5rem;
  font-weight: 700;
  color: ${(props) => props.theme.colors.font.primary};
  text-align: center;
  width: 100%;

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 1.25rem;
  }
`;

export const ModalSubtitle = styled.p`
  margin: 0;
  font-weight: 400;
  text-align: center;
  margin-bottom: ${(props) => props.theme.spacing.large};
  width: 100%;
  font-size: ${(props) => props.theme.fontSizes.small};
  color: #000000;
  line-height: 1.5;
`;

export const VerificationWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${(props) => props.theme.spacing.medium};
  width: 100%;
  margin-bottom: ${(props) => props.theme.spacing.large};
`;

export const StyledInput = styled.input`
  width: 3.5rem;
  text-align: center;
  height: 4.5rem;
  font-size: 2rem;
  border: 1px solid #ECECEC;
  border-radius: 0.5rem;
  background-color: white;
  color: ${(props) => props.theme.colors.font.primary};
  transition: all 0.2s;

  &:focus {
    outline: none;
    border-color: #34d399;
    box-shadow: 0 0 0 2px rgba(52, 211, 153, 0.1);
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    width: 3rem;
    height: 4rem;
    font-size: 1.5rem;
  }
`;

export const AgentLoginFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: auto;
  min-height: auto;
  width: 100%;
  gap: ${(props) => props.theme.spacing.medium};

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    gap: ${(props) => props.theme.spacing.small};
  }
`;

export const WhatsAppInfo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  color: ${(props) => props.theme.colors.font.secondary};
  font-size: ${(props) => props.theme.fontSizes.small};
  font-weight: 500;
  margin-bottom: ${(props) => props.theme.spacing.small};

  img {
    width: auto;
    height: 24px;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.md}) {
    font-size: 0.75rem;

    img {
      height: 20px;
    }
  }
`;
